import { ErrorList } from '../components/admin/ErrorList';

export function AdminErrors() {
  return <ErrorList />;
}
